/**
 * See a reading as a paid reader would, on a dev build only: `?paid=1` turns it on for the tab
 * (remembered), `?paid=0` turns it off. A production build drops this: `import.meta.env.DEV` is
 * false there, so the paid layout is never reachable by a flag, only by an entitlement.
 */
const KEY = "nira.dev.paid"

export function paidPreview(search: string = typeof window === "undefined" ? "" : window.location.search): boolean {
  if (!import.meta.env.DEV) return false
  const asked = new URLSearchParams(search).get("paid")
  try {
    if (asked === "1") sessionStorage.setItem(KEY, "1")
    if (asked === "0") sessionStorage.removeItem(KEY)
    return sessionStorage.getItem(KEY) === "1"
  } catch {
    return asked === "1"
  }
}
